import Vue from 'vue'

Vue.filter('showFullPriceFormat', (number = 0) => {
  const str = parseFloat(number).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return str
})

export default Vue



// WEBPACK FOOTER //
// ./src/utils/filter.js